import { Injectable } from '@angular/core';
import { SERVER_URL } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class NitsRepresentativeService {

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) { }

  /** 
   * Nits by representative 
   * 
   * @author Santiago Osorio 
   * @param {Object} questions - Get groups, nits and players by nit
   * @returns {Promise<String>} - 
   * 
 **/

  getGroupsPlayer(companyId: number, zone: boolean): Promise<any> {
    const url = SERVER_URL + '/api/crm/groups/?company_id=' + companyId + `&zones=` + zone
    const headers = this.authService.getAuthHeaders();
    return this.http.get(url, headers).toPromise();
  }

  getListNits(nit: string, zone: string, anioMes: string, page: number = 0, size: number = 10): Promise<any> {
    page += 1
    let url = SERVER_URL + '/api/crm/list_nits_by_rct/' + anioMes + '?nit=' + nit + `&page=` + page 
    if(zone !== ''){
      url = url + `&zone=` + zone
    }
    const headers = this.authService.getAuthHeaders();
    return this.http.get(url, headers).toPromise();
  }

  getDetallesNits(nit: string, anioMes: string): Promise<any> {
    const url = SERVER_URL + '/api/crm/list_players_by_nit/' + anioMes + '?nit=' + nit
    const headers = this.authService.getAuthHeaders();
    return this.http.get(url, headers).toPromise();
  }

}
